/* eslint-disable */
export const FIREBASE_API = {
    apiKey: 'AIzaSyBernKzdSojh_vWXBHt0aRhf5SC9VLChbM',
    authDomain: 'berry-material-react.firebaseapp.com',
    projectId: 'berry-material-react',
    storageBucket: 'berry-material-react.appspot.com',
    messagingSenderId: '901111229354',
    appId: '1:901111229354:web:a5ae5aa95486297d69d9d3',
    measurementId: 'G-MGJHSL8XW3'
};
//Server Localhost
/*export const URL_API_SERVICE = 'http://127.0.0.1:4000/api/';
export const URL_API_UPLOADS = 'http://127.0.0.1:8001';
export const URL_SERVICES_SRI = 'http://192.168.100.10:8080/ComprobantesElectronicosSri/api/configuraciones/';
export const URL_API_PHP_SERVICES = 'http://127.0.0.1:8060';*/

// Server Farpro en https
export const URL_API_SERVICE = 'https://farpro.disfasur.com/api4000/';
export const URL_API_UPLOADS = 'https://farpro.disfasur.com/uploads8001/';
export const URL_SERVICES_SRI = 'https://farpro.disfasur.com/sri8080/';
export const URL_API_PHP_SERVICES = 'https://farpro.disfasur.com/php8060/';

// /images/account/6_farproadmin_1660402570906.jpeg
// basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
// like '/berry-material-react/react/default'
export const BASE_PATH = '';

export const DASHBOARD_PATH = '/dashboard';

export const SHOW_CONSOLE = false;

const config = {
    fontFamily: `'Roboto', sans-serif`,
    borderRadius: 8,
    outlinedFilled: true,
    navType: 'light', // light, dark
    presetColor: 'default', // default, theme1, theme2, theme3, theme4, theme5, theme6
    locale: 'en', // 'en' - English, 'fr' - French, 'ro' - Romanian, 'zh' - Chinese
    rtlLayout: false,
    container: false,
    jwt: {
        secret: 'SECRET-KEY',
        timeout: '1 days'
    }
};

export default config;
